// Import: Middleware Action & Custom Types
import {
    CLEAN_LIST_TRANSFER_STP,
    CLEAN_LIST_TRANSFER_STP_ERROR,
} from "_models/redux/types";

// Action function
export const cleanTransferSTPClean = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        dispatch({
            type: CLEAN_LIST_TRANSFER_STP,
            payload: undefined,
        });
    } catch (e) {
        dispatch({
            type: CLEAN_LIST_TRANSFER_STP_ERROR,
            payload: undefined,
        });
    }
};
